import { Injectable, signal } from '@angular/core';
import { LegacyPreferenceStorageService } from '../realtime/legacy-preference-storage.service';

@Injectable({ providedIn: 'root' })
export class ShellPreferencesService {
  readonly notificationEnabled = signal(false);
  readonly cancelNotificationEnabled = signal(false);

  constructor(private readonly preferenceStorage: LegacyPreferenceStorageService) {
    this.notificationEnabled.set(this.preferenceStorage.readBoolean('notification', false));
    this.cancelNotificationEnabled.set(
      this.preferenceStorage.readBoolean('notificationCancel', false)
    );
  }

  setNotificationEnabled(enabled: boolean): void {
    this.notificationEnabled.set(enabled);
    this.preferenceStorage.writeBoolean('notification', enabled);
  }

  setCancelNotificationEnabled(enabled: boolean): void {
    this.cancelNotificationEnabled.set(enabled);
    this.preferenceStorage.writeBoolean('notificationCancel', enabled);
  }
}
